import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgJibimo = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='url(#jibimo_svg__a)'
      d='M12.476 1q.03.007.063 0 .524.036 1.035.158a7.1 7.1 0 0 1 2.246.94q.501.325.946.725a7.15 7.15 0 0 1 2.209 3.919q.084.437.113.883v.467a1.136 1.136 0 0 1-2.22.328 1.8 1.8 0 0 1-.058-.41 4.2 4.2 0 0 0-.17-1.224 4.3 4.3 0 0 0-.315-.833 4.8 4.8 0 0 0-.631-.928 5 5 0 0 0-.84-.8 4.8 4.8 0 0 0-2.025-.884 5 5 0 0 0-.688-.07h-.568a4 4 0 0 0-.725.114 4.76 4.76 0 0 0-2.865 1.981A4.65 4.65 0 0 0 7.22 7.26q-.064.35-.063.707.015.142 0 .284a1 1 0 0 1-.227.51 1.11 1.11 0 0 1-1.191.42 1.136 1.136 0 0 1-.841-1.094 6 6 0 0 1 0-.688 7 7 0 0 1 .379-1.685c.176-.5.409-.978.694-1.426a6.5 6.5 0 0 1 1.356-1.583q.488-.423 1.048-.745a7 7 0 0 1 2.271-.826q.415-.094.84-.133z'
    />
    <path
      fill='url(#jibimo_svg__b)'
      d='M12.009 16.629c0-.057 0-.095.038-.14a1.06 1.06 0 0 1 .36-.542l1.028-.82 1.319-1.047 1.356-1.092 1.527-1.218 1.306-1.047.271-.22a.8.8 0 0 1 .43-.178.7.7 0 0 1 .302.038.93.93 0 0 1 .417.278c.21.228.34.518.372.826a2.2 2.2 0 0 1 0 .41l-.076.581c0 .234-.056.473-.088.707s-.044.347-.063.517l-.095.72c0 .233-.057.466-.088.7-.032.233-.044.36-.063.543-.02.182-.044.328-.063.492s-.045.366-.07.549-.044.372-.076.561a4.8 4.8 0 0 1-.378 1.262c-.21.453-.477.877-.795 1.262a7.5 7.5 0 0 1-.757.789 9 9 0 0 1-1.168.89c-.597.381-1.231.702-1.892.958-.55.21-1.119.371-1.698.48a9 9 0 0 1-.706.1c-.24.026-.31 0-.467 0h-.423a7 7 0 0 1-.795-.062 9 9 0 0 1-1.003-.208 9.95 9.95 0 0 1-3.963-2.057c-.132-.12-.265-.24-.384-.36a6.2 6.2 0 0 1-1.067-1.376 5 5 0 0 1-.53-1.312 6 6 0 0 1-.107-.63c0-.184-.044-.367-.07-.55-.025-.183-.044-.372-.069-.561s-.044-.36-.07-.543c-.024-.183-.043-.36-.069-.543-.025-.183-.044-.372-.069-.555a16 16 0 0 1-.063-.536c-.019-.183-.05-.354-.07-.53-.018-.177-.05-.379-.069-.568-.019-.19-.05-.36-.07-.543-.018-.183-.03-.233-.043-.347a1.4 1.4 0 0 1 .044-.429c.052-.24.172-.459.347-.63a.89.89 0 0 1 .63-.31.7.7 0 0 1 .392.101q.107.06.202.139l1.735 1.394 3.268 2.606 1.666 1.319q.145.11.252.258c.11.138.184.3.215.474m0 .214v.095a.49.49 0 0 1-.271.315.8.8 0 0 1-.366.07 3 3 0 0 1-.322-.044 5 5 0 0 1-.492-.164q-.63-.258-1.23-.58a8 8 0 0 1-.79-.462l-.839-.561a7 7 0 0 0-.542-.334 2.5 2.5 0 0 0-.454-.209.7.7 0 0 0-.26-.037.32.32 0 0 0-.308.365q-.005.195.056.379.08.328.228.631.263.582.63 1.104c.274.388.59.746.94 1.066q.195.177.41.329.39.275.808.504c.467.271.965.483 1.483.631.45.129.915.193 1.382.19h.227q.226-.012.448-.05a6 6 0 0 0 1.603-.525q.515-.254.997-.568.456-.298.845-.68.425-.435.782-.928c.275-.382.508-.793.695-1.224q.136-.304.195-.631a.7.7 0 0 0 0-.284.31.31 0 0 0-.214-.215.5.5 0 0 0-.221 0q-.12.022-.234.063a3.6 3.6 0 0 0-.63.34l-.878.575q-.584.39-1.211.707c-.36.176-.726.353-1.104.498q-.25.102-.518.145a1 1 0 0 1-.448 0 .51.51 0 0 1-.39-.378z'
    />
    <path
      fill='url(#jibimo_svg__c)'
      d='M11.157 9.884a.15.15 0 0 1 .057.139v1.369a.75.75 0 0 0 .472.701.757.757 0 0 0 1.049-.701v-1.376a.14.14 0 0 1 .069-.145l.088-.07a1.44 1.44 0 0 0 .46-1.135 1.3 1.3 0 0 0-.422-.902 1.38 1.38 0 0 0-2.139.277 1.4 1.4 0 0 0-.202.631c-.027.327.06.653.246.922q.14.168.322.29'
    />
    <defs>
      <linearGradient
        id='jibimo_svg__a'
        x1={9.072}
        x2={25.942}
        y1={28.944}
        y2={15.506}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#2BB7F2' />
        <stop offset={0.51} stopColor='#4A76F5' />
        <stop offset={1} stopColor='#6F60F4' />
      </linearGradient>
      <linearGradient
        id='jibimo_svg__b'
        x1={7.529}
        x2={23.634}
        y1={20.813}
        y2={4.743}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#2BB7F2' />
        <stop offset={0.51} stopColor='#4A76F5' />
        <stop offset={1} stopColor='#6F60F4' />
      </linearGradient>
      <linearGradient
        id='jibimo_svg__c'
        x1={10.753}
        x2={12.962}
        y1={11.562}
        y2={7.732}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#2BB7F2' />
        <stop offset={0.51} stopColor='#4A76F5' />
        <stop offset={1} stopColor='#6F60F4' />
      </linearGradient>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgJibimo)
export default ForwardRef
